import { render, staticRenderFns } from "./TherapistDashModalDeleteExpenditure.vue?vue&type=template&id=7ae77994&scoped=true"
import script from "./TherapistDashModalDeleteExpenditure.vue?vue&type=script&lang=js"
export * from "./TherapistDashModalDeleteExpenditure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae77994",
  null
  
)

export default component.exports